/* src/app/location-users/add-location-users/new-user-queue/new-user-queue-location/new-user-queue-location.component.scss */
ul {
  padding-left: 20px;
  list-style: none;
}
ul li {
  border-bottom: 1px solid #6E6E6E;
}
ul li:last-of-type {
  border-bottom: none;
}
.user-queue-location-entry {
  background-color: #DDD7D0;
  font-weight: 600;
  padding: 10px;
}
/*# sourceMappingURL=new-user-queue-location.component.css.map */
